import { LoadingState } from "../domain/data-layer/loading-state";
import { SwarovskiPageData, SwarovskiPageDataFrontend } from "@swo/storefront";
import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";

export function useScrollToTopLinkEffect(
  maybePage: { data: LoadingState<SwarovskiPageDataFrontend> },
  scrollToTop?: boolean,
) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (maybePage.data.__tag === "loaded") {
      if (scrollToTop) {
        void navigate(location, {
          replace: true,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          state:
            typeof location.state === "object" && location.state !== null
              ? {
                  ...location.state,
                  scrollToTop: undefined,
                }
              : { scrollToTop: undefined },
        });

        window.scrollTo({ top: 0 });
      }
    }
  }, [maybePage, scrollToTop]);
}
